import { render } from "./SelectBranch.vue?vue&type=template&id=ef6bd50e&scoped=true"
import script from "./SelectBranch.vue?vue&type=script&lang=js"
export * from "./SelectBranch.vue?vue&type=script&lang=js"

import "./SelectBranch.vue?vue&type=style&index=0&id=ef6bd50e&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6bd50e"]])

export default __exports__